var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import RcDrawer from 'rc-drawer';
import PropTypes from 'prop-types';
import createReactContext from 'create-react-context';
import isNumeric from '../_util/isNumeric';
const DrawerContext = createReactContext(null);
export default class Drawer extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            push: false,
        };
        this.close = (e) => {
            if (this.props.visible !== undefined) {
                if (this.props.onClose) {
                    this.props.onClose(e);
                }
                return;
            }
        };
        this.onMaskClick = (e) => {
            if (!this.props.maskClosable) {
                return;
            }
            this.close(e);
        };
        this.push = () => {
            this.setState({
                push: true,
            });
        };
        this.pull = () => {
            this.setState({
                push: false,
            });
        };
        this.renderBody = () => {
            const { destroyOnClose, visible, width, placement } = this.props;
            if (destroyOnClose && !visible) {
                return null;
            }
            const { prefixCls, title, closable } = this.props;
            let header;
            if (title) {
                header = (<div className={`${prefixCls}-header`}>
          <div className={`${prefixCls}-title`}>{title}</div>
        </div>);
            }
            let closer;
            if (closable) {
                closer = (<button onClick={this.close} aria-label="Close" className={`${prefixCls}-close`}>
          <span className={`${prefixCls}-close-x`}/>
        </button>);
            }
            let containerStyle = { width };
            if (placement === 'left' || placement === 'right') {
                containerStyle = {
                    overflow: 'auto',
                    height: '100%',
                    width,
                };
            }
            return (<div style={containerStyle}>
        {header}
        {closer}
        <div className={`${prefixCls}-body`} style={this.props.style}>
          {this.props.children}
        </div>
      </div>);
        };
        this.renderProvider = (value) => {
            let _a = this.props, { width, zIndex, style, placement } = _a, rest = __rest(_a, ["width", "zIndex", "style", "placement"]);
            if (isNumeric(width)) {
                width = `${width}px`;
            }
            const RcDrawerStyle = this.state.push
                ? {
                    zIndex,
                    transform: `translateX(${placement === 'left' ? 180 : -180}px)`,
                }
                : { zIndex };
            this.praentDrawer = value;
            return (<DrawerContext.Provider value={this}>
        <RcDrawer {...rest} handler={false} open={this.props.visible} onMaskClick={this.onMaskClick} showMask={this.props.mask} placement={placement} style={RcDrawerStyle}>
          {this.renderBody()}
        </RcDrawer>
      </DrawerContext.Provider>);
        };
    }
    componentDidUpdate(preProps) {
        if (preProps.visible !== this.props.visible && this.praentDrawer) {
            if (this.props.visible) {
                this.praentDrawer.push();
            }
            else {
                this.praentDrawer.pull();
            }
        }
    }
    render() {
        return (<DrawerContext.Consumer>{this.renderProvider}</DrawerContext.Consumer>);
    }
}
Drawer.propTypes = {
    closable: PropTypes.bool,
    destroyOnClose: PropTypes.bool,
    getContainer: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.func,
        PropTypes.bool,
    ]),
    maskClosable: PropTypes.bool,
    mask: PropTypes.bool,
    maskStyle: PropTypes.object,
    style: PropTypes.object,
    title: PropTypes.node,
    visible: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    wrapClassName: PropTypes.string,
    zIndex: PropTypes.number,
    prefixCls: PropTypes.string,
    placement: PropTypes.string,
    onClose: PropTypes.func,
};
Drawer.defaultProps = {
    prefixCls: 'ant-drawer',
    width: 256,
    closable: true,
    placement: 'right',
    maskClosable: true,
    level: null,
};



// WEBPACK FOOTER //
// ./components/drawer/index.tsx